/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { BCodeService } from '@src/app/modules/budget/bcode.service';
import { Txn } from '@src/app/model/txn';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet } from '@src/app/shared/form/field-set/field-set.component';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { TxnService } from '@src/app/modules/txn/txn.service';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { TxnPageNavRoute } from '@src/app/routes/txn-page-nav';

@Component({
    selector: 'app-txn-page',
    templateUrl: './txn-page.component.html',
    styleUrls: ['./txn-page.component.scss'],
    imports: [FormPageComponent]
})
export class TxnPageComponent extends AbstractPageComponent {
    dataSvc = inject(TxnService);
    bCodeSvc = inject(BCodeService);


    config = new FormConfig({
        navRoute: TxnPageNavRoute,
        title: 'Transactions',
        help: $localize`Financial transactions`,
        fieldSet: new FieldSet({
            fields: this.dataSvc.getFields(),
            formLayout: [
                { cells: [{ width: '25%' }, { width: '25%' }, { width: '25%' }, { width: '25%' }] },
                { cells: [{ colspan: 4, pageTab: 'yes' }] }
            ],
        }),
        service: this.dataSvc,
        mode: 'list',
        //pathEdit: (o: Txn) => Txn.getType(o.typeId).code + '/' + o.id
        pathEdit: (o: Txn) => Txn.getTxnLink(o)
    });
}
